import { render, staticRenderFns } from "./LCL.vue?vue&type=template&id=aa5927ae"
import script from "./LCL.vue?vue&type=script&lang=js"
export * from "./LCL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports